import styled from "styled-components";
import {
  DataHeading,
  UnderlineLink,
  SectionLastHeading,
  DisplayFlex,
  SecondaryButtonComponent,
  GhostButtonComponent
} from "../../../../CommonComponents/commonStyles";
import {Row, Table, Modal, Divider, Select, Form, Dropdown } from "antd";

export const ExchangeContainer = styled.div`
  margin-top: 170px .exchange-activity-heading {
    font-size: 16px;
  }
  .exchanges .ant-tabs-bar {
    border-bottom: 1px solid #e8e8e8 !important;
  }
  .exchanges .singleEx-img {
    margin-top: 13px;
  }
`;
export const LabelDataHeading = styled(DataHeading)`
  color: #505050;
`;
export const ValueDataHeading = styled(DataHeading)`
  color: #505050;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  text-transform: capitalize;
`;
export const ExchangeTable = styled(Table)`
  .ant-table-thead
    > tr
    > th.ant-table-column-has-actions.ant-table-column-has-sorters,
  .ant-table-thead
    > tr
    > th.ant-table-column-has-actions.ant-table-column-has-filters {
    padding-right: 0px !important;
  }
  .ant-table-tbody > tr > td {
    border: none !important;
    // letter-spacing: 0.5px;
    padding: 0px 0px 0px 20px !important;
  }
  .ant-table-tbody > tr > td:last-child {
    padding: 20px 20px 20px 20px !important;
  }

  .ant-table-thead > tr > th {
    padding: 20px 0px 20px 20px !important;
  }
  .ant-table-tbody > tr:nth-child(odd) {
    background-color: #f4f3f3;
  }
  .ant-table-fixed-header {
    .ant-table-scroll {
      .ant-table-header {
        padding-bottom: 0px !important;
        margin-bottom: -6px !important;
        background: #ffffff;
      }
      border-width: 0px 1px 1px 1px !important;
      border-style: solid !important;
      border-color: #eaeaea !important;
    }
  }

  th {
    background: #fff !important;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    color: #022737 !important;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.38;
    // letter-spacing: 0.6px;
  }

  &&& {
    .ant-table-thead tr th .ant-table-column-sorter {
      transform: translate(0px, 0px);
    }
  }

  .ant-table-thead {
    tr {
      th {
        .ant-table-column-sorter {
          left: 0px;
          right: 0px;
          top: 11px;
        }
        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-bottom-color: #eaeaea;
      }
    }
  }
`;

export const UnderlyingContent = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const TableLabel = styled.div`
  text-transform: capitalize;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 15px;
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  // letter-spacing: 0.5px;
  color: ${props => props.theme.fontColors.raeCardFooter};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const CustomModal = styled(Modal)`
  .ant-modal-header {
    padding: 0px 0px 30px 0px;
    border-bottom: 2px solid #b6bdbd;
    @media only screen and (max-width: 576px) {
      padding: 0px 0px 15px 0px;
    }
  }
  .ant-modal-footer {
    padding: 30px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    div {
      margin-top: 20px;
    }
    @media only screen and (max-width: 991px) {
      padding-top: 0;
      margin-top: auto;
    }
  }
  .ant-modal-body {
    padding: 12px 0px 10px 0px .ant-table-wrapper {
      border-top: 1px solid #b6bdbd;
    }
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 30px @media only screen and (max-width: 576px) {
      padding: 30px 20px;
    }

    @media only screen and (max-width: 991px) {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 97vh;
    top: 10px;
    padding: 0;
  }
  @media only screen and (max-width: 576px) {
    top: 0px !important;
  }
`;
export const ModalHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.bold};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.oneP17};
  // letter-spacing: ${props => props.theme.letterSpacing.normal}
  color: #022737;
  text-align: center
`;

export const ContentDivider = styled(Divider)`
  border: solid 0.5px rgba(255, 255, 255, -10.7);
  margin-top: 20px;
  margin-bottom: 15px;
`;
export const CardPopContainer = styled.div`
  height: 400px;
  overflow-y: auto @media (max-width: 991px) {
    height: 60vh;
  }
  @media (max-width: 425px) {
    height: 40vh;
  }
  @media (max-width: 414px) {
    height: 52vh;
  }
  @media (max-width: 411px) {
    height: 50vh;
  }
  @media (max-width: 375px) {
    height: 44vh;
  }
  @media (max-width: 360px) {
    height: 46vh;
  }
  @media (max-width: 320px) {
    height: 35vh;
  }
`;
export const CardPopContainerPending = styled.div`
  height: 400px;
  overflow-y: auto @media (max-width: 991px) {
    height: 60vh;
  }
  @media (max-width: 414px) {
    height: 40vh;
  }
  @media (max-width: 411px) {
    height: 42vh;
  }
  @media (max-width: 375px) {
    height: 31vh;
  }
  @media (max-width: 360px) {
    height: 32vh;
  }
  @media (max-width: 320px) {
    height: 22vh;
  }
`;
export const SectionHeading = styled(SectionLastHeading)`
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  color: #022737;
`;

export const SectionDivider = styled(Divider)`
  border: solid 2px #bfbfbf;
  margin-top: 49px;
  margin-bottom: 49px;
`;
export const HideArrow = styled.div`
  &&& .ant-select-dropdown:after {
    bottom: 0;
  }
`;
export const WrapLabel = styled.div`
&&& {
  .ant-form-item-label{
    margin-bottom: 10px;
   }
   @media only screen and (min-width: 320px) and (max-width: 767px) {  
    &&& {
      .ant-form-item-label{
        padding: 0;
       }
   }
}
`;

export const LabelWrapper = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.25;
  // letter-spacing: 0.6px;
  color: #505050;
  font-weight: normal;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const InputWrapper = styled.div`
  // width: 274px;
  input,
  .ant-select-selection--single {
    height: 40px;
  }
  .ant-input {
    border: solid 1px #d4d4d4;
    border-radius: 0;
  }
`;

export const GrantDropdown = styled(Select)`

.ant-select-selection {
  z-index:1 !important;
  border-radius: 0px
}
.ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{
  border-color: rgba(11, 178, 167, 0.1);
  box-shadow: 0 0 0 1px rgba(11, 178, 167, 0.1)
}
.ant-select-selection: hover{
  border-color: rgba(11, 178, 167, 0.1);

}
&&&{
  .ant-select-arrow{
    background-color: #d4d4d4;
    color: #60606A
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
`;
export const SelectOptionWrapper = styled.div`
  .ant-select-dropdown:after {
    background: red;
    bottom: 0;
  }
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.tbody};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: 2.15;
  padding: 2px 0;
  font-weight: normal;
  &:hover {
    color: #167f91;
  }
`;
export const SelectDropdown = styled(SelectOptionWrapper)`
  .ant-select-dropdown:after {
    background: red;
    bottom: 0;
  }
  font-family: HelveticaNeue;
  font-size: 14px;
  letter-spacing: 0.6px;
  color: ${props => props.theme.colors.dropdownArrow};
`;

export const FormContainer = styled(Form)`
  &&& {
    // margin-top: ${props => props.theme.spacing.margins.YBetween};
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    // .ant-form-item{
    //   margin-bottom: 40px;
    // }
    //radio label
    // .ant-form-item label{
    //   margin-bottom: 20px;
    // }
    .ant-form-item-control{
        line-height: normal;
      }
  }
  // @media only screen and (min-width: 320px) and (max-width: 767px) {
  //   &&& {
  //   .ant-form-item{
  //     margin-bottom: 30px;
  //   }
  }
  }
`;

export const Para = styled.div`
  span {
    display: block;
  }
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: 0.6px;
  color: #505050;
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    letter-spacing: normal;
  }
`;
export const SubSectionLabel = styled(TableLabel)`
  line-height: 1.25;
  //font-weight: bold;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const RadioWrapper = styled.div`
  width: 650px;
  &&& .ant-form-item label {
    margin-bottom: 30px;
    display: flex;
    white-space: pre-wrap;
  }
  &&&.ant-form-item label: nth-child(2) {
    margin-bottom: 15px;
  }
  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-inner {
    height: 16px;
    top: 3px;
  }
  .ant-form-item {
    margin-bottom: 0px;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    &&& .ant-form-item label {
      margin-bottom: 20px;
    }
    span.ant-radio + * {
      padding-right: 0px;
    }
    .ant-radio-wrapper:hover .ant-radio,
    .ant-radio:hover .ant-radio-inner,
    .ant-radio-inner {
      top: 1px;
    }
  }
`;
export const RadioLabelWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  letter-spacing: 0.6px;
  color: #505050;
  font-weight: normal;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const CommentsMargin = styled.div`
  .ant-form-item {
    margin-bottom: 15px;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 15px;
    margin-left: 20px;
  }
`;
export const CheckboxWrapper = styled.div`
  .ant-checkbox-wrapper {
    display: flex;
  }
  .ant-checkbox {
    top: 8px;
  }
`;
export const CheckboxMargin = styled.div`
  .ant-form-item {
    margin-bottom: 0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 20px;
  }
`;
export const CheckboxContent = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: normal;
  line-height: 1.5;
  // letter-spacing: 0.7px;
  color: #505050;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 1.57;
    letter-spacing: normal;
  }
`;
export const InputMargin = styled.div`
  .ant-form-item {
    margin-bottom: 40px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .ant-form-item {
      margin-bottom: 30px;
    }
  }
`;
export const LastInputMargin = styled.div`
  .ant-form-item {
    margin-bottom: 10px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .ant-col-md-6,
    .ant-col-lg-6,
    .ant-col-xs-24 {
      position: unset;
    }
  }
`;
export const ErrorMsgWrap = styled.div`
  margin-top: 5px;
  font-family: HelveticaNeue;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.25;
  letter-spacing: 0.6px;
  color: #f74c52;
`;

export const LastNameWrapper = styled.div`
  /* margin-left: 20px; */
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0;
    margin-top: 20px;
  }
`;
export const GrantContentWrapper = styled.div`
  position: relative;
  left: 20px;
  top: 5px;
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  // letter-spacing: 0.6px;
  color: #505050;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    left: 0;
  }
`;
export const SearchResultText = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.heading};
  margin-bottom: 5px;
  color: #505050;
`;

export const DisplayResultText = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  margin-bottom: 5px;
  color: #505050;
`;

export const CustomModalPending = styled(Modal)`
  .ant-modal-header {
    padding: 0px 0px 30px 0px;
    @media only screen and (max-width: 576px) {
      padding: 0px 0px 15px 0px;
    }
    @media only screen and (max-width: 767px) {
      padding: 0px 0px 10px 0px;
    }
  }
  .ant-modal-footer {
    padding: 30px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    div {
      margin-top: 20px;
    }
    @media only screen and (max-width: 991px) {
      padding-top: 0;
      margin-top: auto;
    }
  }
  .ant-modal-body {
    padding: 12px 0px 10px 0px;
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 30px @media only screen and (max-width: 576px) {
      padding: 30px 20px;
    }

    @media only screen and (max-width: 991px) {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 97vh;
    top: 10px;
    padding: 0;
  }
  @media only screen and (max-width: 576px) {
    top: 0px !important;
  }

  .ant-modal-close-x {
    @media only screen and (max-width: 768px) {
      line-height: 35px;
    }
  }
`;
export const AddButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 203px;
  height: 30px;

  background-color: ${props => props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: normal;
    padding-left: 0.25rem;
  }

  @media only screen and (max-width: 991.92px) {
    align-self: center;
    margin-left: 0;
  }
`;

export const ButtonWrapper = styled(DisplayFlex)`
  margin-top: 50px;
  margin-bottom: 80px;
  justify-content: space-between;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: row;
    margin-top: 30px;
    margin-bottom: 15px;
  }
`;
export const GrantDisplayFlex = styled(DisplayFlex)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const GrantGhostButton = styled(GhostButtonComponent)`
  width: 177px;
  margin-right: 15px;
  font-size: ${props => props.theme.fontSize.heading};
  font-weight: 900;
  line-height: 1.67;
  letter-spacing: 1.1px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    margin-bottom: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
export const GrantPrimaryButtonWrapper = styled.div`
  width: 177px;
  font-size: ${props => props.theme.fontSize.heading};
  font-weight: 900;
  letter-spacing: 1.1px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    margin-bottom: 70px;
  }
`;

export const DeleteModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      border-radius: 0px;
    }
    .ant-modal-header {
      padding: 15px 30px 15px 30px;
      background: #fff;
      border-radius: unset;
      @media (max-width: 576px) {
        padding: 10px 15px;
      }
    }
    .ant-modal-title {
      text-align: center;
      font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
      font-size: ${props => props.theme.fontSize.h4};
      font-weight: ${props => props.theme.fontWeight.normal};
      line-height: ${props => props.theme.lineHeight.h4};
      color: ${props => props.theme.fontColors.headingColor};
    }
    .ant-modal-footer {
      padding: 16px 20px;
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid #dddddd;
      border-radius: 0 0 4px 4px;
    }
  }
`;

export const GrantInputRadio = styled.div`
  margin-bottom: 30px;
`;

export const SelectTab = styled(Select)`
width: 200px;
max-width: 200px;
height:40px;

.ant-select-selection{
  border-radius : 0px;
}

& .ant-select-selection--multiple .ant-select-selection__placeholder{
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color:   color: ${props => props.theme.fontColors.tbody}!important;;
}

.ant-select-selection__rendered > ul > li{
  // margin-top:7px;
}

.ant-select-arrow{
  top: 0;
    padding: 13px 13px;
    background-color:${props => props.theme.colors.dropdownArrow};;
    margin: 1px 1px;
    right: 0;
    bottom: 0;
}
`;

export const ViewMoreButton = styled(SecondaryButtonComponent)`
  min-width: 103px;
  max-width: 103px;
  font-size: ${props => props.theme.fontSize.secondary};
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  text-decoration: none;
  padding: 0px 8px;
  line-height: ${props => props.theme.lineHeight.normal} !important;
  letter-spacing: ${props => props.theme.letterSpacing.zero} !important;
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primaryColor};
    border: 1px solid ${props => props.theme.colors.border};
  }
  @media only screen and (max-width: 990px) {
    margin: 0px;
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (min-width: 576px) and (max-width: 991px) {
    margin: 0px;
    // width: 20% !important;
    // min-width: 20% !important;
  }
`;

export const DropdownList = styled(Dropdown)`
  z-index: 1 !important;
  & > .ant-dropdown {
    z-index: 1 !important;
    left: 15.5px;
    top: 520px;
    width: 85%;
  }
`;

export const Underlined = styled.a`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: underline;
  margin-left: 20px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  &:hover {
    color: ${props => props.theme.colors.primaryColor};
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.normal};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.normal};
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
`;

export const TextWrapper = styled.span`
  p {
    display: inline-block;
    margin: 0;
  }
  a{
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.normal};
    color: rgb(0, 103, 120) !important;
    text-decoration: underline;
  }
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.colors.tabHead};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const StepFlexRowExg = styled(Row)`
  display: flex;
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    margin-top: 20px;
  }
`;
